module.exports = __webpack_public_path__ + "static/2022_ESG_REPORT_eng-7ce8f57358e4292e25637cdcef91fb3d.pdf";